// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-1f6b939c] {\n  max-height: calc(100vh - 340px) !important;\n}\n.table td[data-v-1f6b939c] {\n  vertical-align: top !important;\n}\n.link-button[data-v-1f6b939c] {\n  padding-right: 10px;\n}\n.link-button i[data-v-1f6b939c] {\n  margin-right: 0;\n}\n.no-wrap[data-v-1f6b939c] {\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
